<div #scrollContainer class="flip-assessment-side-card-main-card">
  <div *ngFor="let group of flipAssessmentGroups">
    <div class="flip-assessment-side-card-group">
      {{ group.name }}
    </div>
    <mat-card-content class="flip-assessment-side-card-scrollable-content">
      <div *ngFor="let item of group.items">
        <app-flip-item-summary
          (editClicked)="handleEditClicked($event)"
          [assessmentItemDto]="item"
          [buttonType]="
            item.score === null ? 'Blank' : item.score ? 'Mostly' : 'Rarely'
          "
          [description]="item.name"
          [edited]="item.edited"
          [number]="item.itemNumber"
          [score]="
            item.score === null ? 'Blank' : item.score ? 'Mostly' : 'Rarely'
          "
          [selected]="item.selected"
        ></app-flip-item-summary>
      </div>
    </mat-card-content>
  </div>
</div>
